// extracted by mini-css-extract-plugin
module.exports = {"tpg-form":"styles_tpg-form__j0stT","error":"styles_error__9FnAR","policy":"styles_policy__yFTRe","contact-image":"styles_contact-image__Ppgbm"};